/* Collection head, option E (2026-10-08). Progressive enhancement for
   blocks/ai_gen_block_992c7fa.liquid; without it the head and tabs still render and work as links.
   1. Description: always shown in full (2026-10-10); no script needed.
   2. Sort: mirror the product grid's Sort (AP Product Grid Pro) into the bar.
   3. Bar: stays under the header while the product grid is on screen (follows Dawn's
      show-on-scroll-up header), then releases.
   4. Rails: bring the active tab / category into view. */
(function () {
  var head = document.querySelector('[data-apch-head]');
  if (!head || head.dataset.apchReady) return;
  head.dataset.apchReady = '1';

  var mobile = window.matchMedia('(max-width: 989px)');
  var wrap = head.querySelector('[data-apch-barwrap]');
  if (!wrap) return;
  var bar = wrap.querySelector('[data-apch-bar]');

  /* 2. Sort */
  var gridSort = document.querySelector('[data-apgp-sort]');
  var proxyBox = wrap.querySelector('[data-apch-sort]');
  var proxy = wrap.querySelector('[data-apch-sort-select]');
  var gridLabel = gridSort && gridSort.closest('.apgp-sort');
  // Only merge when there are tabs; a lone Sort above merchandising sections reads as orphaned.
  var hasTabs = !wrap.classList.contains('apch-barwrap--notabs');
  if (hasTabs && gridSort && proxy && gridLabel && getComputedStyle(gridLabel).display !== 'none') {
    Array.prototype.forEach.call(gridSort.options, function (o) {
      proxy.appendChild(new Option(o.text, o.value, false, o.selected));
    });
    proxy.value = gridSort.value;
    proxy.addEventListener('change', function () {
      gridSort.value = proxy.value;
      gridSort.dispatchEvent(new Event('change', { bubbles: true }));
      var grid = document.querySelector('[data-apgp-grid]');
      if (grid) {
        var top = grid.getBoundingClientRect().top;
        if (top > window.innerHeight * 0.6) {
          window.scrollTo({ top: window.scrollY + top - bar.offsetHeight - 120, behavior: 'smooth' });
        }
      }
    });
    gridSort.addEventListener('change', function () { proxy.value = gridSort.value; });
    proxyBox.hidden = false;
    wrap.classList.add('has-sort');
    var toolbar = gridLabel.closest('.apgp-toolbar');
    if (toolbar) {
      toolbar.classList.add('apch-sort-merged');
      var section = toolbar.closest('.shopify-section');
      var sectionInner = section && section.firstElementChild;
      if (sectionInner && !toolbar.querySelector('.apgp-filters')) sectionInner.classList.add('apch-grid-merged');
    }
  }

  /* Match the bar to the background it sits on */
  var el = wrap.parentElement;
  while (el && el !== document.documentElement) {
    var bg = getComputedStyle(el).backgroundColor;
    if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') { wrap.style.setProperty('--apch-bar-bg', bg); break; }
    el = el.parentElement;
  }

  /* 3. Sticky bar, scoped to the product grid */
  function findGrid() { return document.querySelector('[data-apgp-grid]') || document.querySelector('#product-grid'); }
  var header = document.querySelector('.section-header');
  var queued = false;
  function place() {
    queued = false;
    var grid = findGrid(); // re-query: the grid can be re-rendered by sort/filter/pagination
    if (!grid || !grid.isConnected || (wrap.classList.contains('apch-barwrap--notabs') && !wrap.classList.contains('has-sort'))) return;
    var top = 0;
    if (header && getComputedStyle(header).position === 'sticky') {
      top = Math.max(0, Math.floor(header.getBoundingClientRect().bottom)); // floor: tuck under the header edge, no sub-pixel gap
    }
    var h = bar.offsetHeight;
    var wrapTop = wrap.getBoundingClientRect().top;
    var gridBottom = grid.getBoundingClientRect().bottom;
    var fixed = wrapTop < top && gridBottom > top + h;
    if (fixed) {
      wrap.style.height = h + 'px';
      wrap.style.setProperty('--apch-top', top + 'px');
    }
    if (fixed !== wrap.classList.contains('is-fixed')) {
      wrap.classList.toggle('is-fixed', fixed);
      if (!fixed) wrap.style.height = '';
    }
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(place); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  if (header && window.MutationObserver) {
    // Dawn reveals/hides the header by class + CSS animation after the scroll event; follow it briefly.
    new MutationObserver(function () {
      var until = performance.now() + 600;
      (function follow() { place(); if (performance.now() < until) requestAnimationFrame(follow); })();
    }).observe(header, { attributes: true, attributeFilter: ['class'] });
  }
  place();

  /* 4. Rails: only scroll when the active item is cut off */
  function reveal(rail, active, pad) {
    if (!rail || !active) return;
    var r = rail.getBoundingClientRect();
    var a = active.getBoundingClientRect();
    if (a.right > r.right - pad || a.left < r.left) {
      rail.scrollTo({ left: rail.scrollLeft + a.left - r.left - (r.width - a.width) / 2, behavior: 'instant' });
    }
  }
  function revealAll() {
    var tabs = wrap.querySelector('[data-apch-tabs-rail]');
    reveal(tabs, tabs && tabs.querySelector('.is-active'), 28);
    var strip = document.querySelector('.apch-nav--strip .apch-rail');
    reveal(strip, strip && strip.querySelector('.apch-item.active'), 12);
  }
  revealAll();
  window.addEventListener('load', revealAll);
})();
